import {
  CARDS_GRID_DENSE_COLUMN_SPACING,
  CARDS_GRID_ITEM_SIZE_BY_DENSITY,
  CardsGridDensity,
} from '@app/components/base/content-structure/cards-grid-config';

/**
 * Shared horizontal padding (theme spacing units) for fragment card content
 * and card media overlays so content and pills align.
 * 1.5 for viewports < xl, 2 for xl and up.
 */
export const FRAGMENT_CARD_PADDING_X = { xs: 1, md: 1.5, xl: 2 };

/** Alias of CardsGridDensity — prefer importing from content-structure/cards-grid-config. */
export type FragmentGridViewMode = CardsGridDensity;

/** Alias of CARDS_GRID_ITEM_SIZE_BY_DENSITY — prefer importing from cards-grid-config. */
export const FRAGMENTS_GRID_ITEM_PROPS_BY_VIEW_MODE = CARDS_GRID_ITEM_SIZE_BY_DENSITY;

/** Alias of CARDS_GRID_DENSE_COLUMN_SPACING — prefer importing from cards-grid-config. */
export const FRAGMENTS_GRID_SPACING = CARDS_GRID_DENSE_COLUMN_SPACING;

/** Number of skeleton cards shown while the fragments list is loading. */
export const FRAGMENTS_LIST_SKELETON_CARD_COUNT = 3;

/** Number of skeleton cards shown while the fragments grid is loading. */
export const FRAGMENTS_GRID_SKELETON_CARD_COUNT = 6;

/** List view: width (px) of the media column in list layout cards. */
export const FRAGMENT_LIST_CARD_MEDIA_WIDTH = {
  md: 180,
  lg: 180,
  xl: 200,
};

/** List view: max width and centering. Used by list card and list section container. */
export const FRAGMENT_LIST_CONTAINER_SX = {
  maxWidth: 'xl' as const,
};
